<script>
  import { link } from 'svelte-spa-router';
  import { t } from '../i18n/index.js';

  /**
   * The product mark: the theme's logo (a decorative background image read
   * from `--brand-logo`), the "sdi." wordmark, what it stands for and who
   * makes it. With `href` it is the way home; without, a plain heading block
   * (login, boot and error screens).
   */
  export let href = null;
  export let onNavigate = undefined;
</script>

{#if href}
  <!-- The accessible name is the visible text plus where the link goes. -->
  <a class="brand" {href} use:link on:click={onNavigate}>
    <span class="brand-logo" aria-hidden="true"></span>
    <span class="brand-word">{$t('brand.wordmark')}<span class="brand-word-dot">.</span></span>
    <span class="brand-caption">{$t('brand.caption')}</span>
    <span class="brand-caption">{$t('brand.owner')}<span class="sr-only"> — {$t('brand.homeHint')}</span></span>
  </a>
{:else}
  <div class="brand brand-standalone" role="img" aria-label={$t('brand.label')}>
    <span class="brand-logo"></span>
    <span class="brand-word">{$t('brand.wordmark')}<span class="brand-word-dot">.</span></span>
    <span class="brand-caption">{$t('brand.caption')}</span>
    <span class="brand-caption">{$t('brand.owner')}</span>
  </div>
{/if}
